import { NavItemType } from 'types/index.types';
import { LocalShipping } from '@mui/icons-material';

import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';
import { jotaiStore } from 'App';
import { filterCriteriaAtom } from 'ui-component/shipping/ShippingTable';

const MountingOrdersPage = Loadable(lazy(() => import('views/pages/mountingOrders/MountingOrdersPage')));

const mountingOrders: NavItemType = {
    id: 'mountingOrders',
    title: 'components.menu.mounting_orders',
    icon: LocalShipping,
    type: 'item',
    url: '/mounting/orders',
    breadcrumbs: false,
    component: <MountingOrdersPage />,
    onClick: () =>
        jotaiStore.set(filterCriteriaAtom, {
            shippingNum: '',
            factory: 'All',
            country: 'All',
            status: 'All'
        }),
    probhitedRoles: ['client']
};

export default mountingOrders;
